import Newsletter from './Newsletter.component';
export default Newsletter;